import { FC, ReactNode, useCallback } from 'react'

import { Button } from '@/components/atoms/Button'

import { UserInfo } from '@/services/user'
import { usePaymentModal } from '@/lib/hooks/usePaymentModal'

interface SubscribeButtonProps {
  userInfo: UserInfo
  amount: number
  activityId?: string
  children: ReactNode
}

export const SubscribeButton: FC<SubscribeButtonProps> = ({
  userInfo,
  amount,
  activityId,
  children,
}) => {
  const { presentPaymentModal } = usePaymentModal({
    userInfo,
    amount,
    activityId,
    paymentType: 'subscription',
  })

  const onClick = useCallback(
    (e) => {
      e.stopPropagation()
      presentPaymentModal()
    },
    [presentPaymentModal]
  )

  return (
    <Button onClick={onClick} className="mx-auto">
      {children}
    </Button>
  )
}
